module.exports = __webpack_public_path__ + "static/img/news4_2.9d0a7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news4_2.jpg
// module id = 57am
// module chunks = 0